<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16.0035400390625"
    viewBox="0 0 16 16.0035400390625"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.2,0.01C11.2,0.01,11.05,0.01,11.05,0.01C11.030000000000001,0.01,11.02,0,11,0C11,0,5,0,5,0C4.98,0,4.97,0.01,4.95,0.01C4.95,0.01,4.8,0.01,4.8,0.01C4.36,0.01,4,0.38,4,0.83C4,0.83,4,15.58,4,15.58C4,16.03,4.25,16.14,4.57,15.82C4.57,15.82,7.4399999999999995,12.88,7.4399999999999995,12.88C7.75,12.56,8.26,12.56,8.57,12.88C8.57,12.88,11.440000000000001,15.82,11.440000000000001,15.82C11.75,16.14,12.01,16.03,12.01,15.58C12.01,15.58,12.01,0.83,12.01,0.83C12,0.38,11.64,0.01,11.2,0.01C11.2,0.01,11.2,0.01,11.2,0.01Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Bookmark',
} as DefineComponent
</script>
